import { Component, Input, OnInit } from '@angular/core';
import { Profile } from 'src/app/interfaces/user';
import { RouterService } from 'src/app/services/router/router.service';

@Component({
  selector: 'app-profile-image',
  templateUrl: './profile-image.component.html',
  styleUrls: ['./profile-image.component.scss']
})
export class ProfileImageComponent implements OnInit {
  
  @Input() firstName: string | undefined;
  @Input() profile: Profile | null | undefined;
  @Input() isNavigate: boolean = false;
  @Input() isRemoved = false;
  @Input() isProfileHidden = false;

  imageErrorOccurred = false;

  constructor(
    private routerService: RouterService
  ) { }

  ngOnInit(): void {
  }

  navigateToProfileDetail(): void {
    if (!this.isNavigate || this.isRemoved) {
      return;
    }
    if (this.profile && this.profile.uniqueName) {
      this.routerService.navigate(this.profile.uniqueName);
    }
  }
}
